import {Component, Input} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";

@Component({
    selector: 'tva-input-error',
    templateUrl: './tv-action-input-error.component.html',
    styleUrls: ['./tv-action-input-error.component.scss']
})
export class TvActionInputErrorComponent {
    @Input() control: FormControl | FormGroup;
    @Input() messages: any;

    constructor() {
    }

    listErrors(): any{
        return Object.keys(this.control.errors || {});
    }

    isShown(): boolean {
        return this.control.invalid && this.listErrors().length > 0;
    }
}
